import axios from '@/lib/axios';
import { RelatedOrder } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0650. 発注案件関連受注案件登録
 * [POST] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/related_orders
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  sales_order_id: number;
  allocation_ratio: number;
};
const createRelatedOrder = (props: Props): Promise<RelatedOrder> => {
  return axios.post(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/related_orders`,
    props
  );
};

export const useCreateRelatedOrder = () => {
  return useMutation({
    mutationFn: createRelatedOrder,
  });
};
